<mat-menu #menu="matMenu" [overlapTrigger]="false">
  <button mat-menu-item *ngIf="!isValidator && !isAdmin" (click)="clickDirectoryTree()" type="button">
    <mat-icon>folder</mat-icon>
    <span>{{ 'dataManagement.directory.title' | transloco }}</span>
  </button>
  <button mat-menu-item *ngIf="!isValidator" (click)="clickExportList()" type="button">
    <mat-icon>ios_share</mat-icon>
    <span>{{ 'dataManagement.exportList.title' | transloco }}</span>
  </button>
  <button mat-menu-item *ngIf="isValidator" (click)="clickValidatorSystems()" type="button">
    <mat-icon>folder</mat-icon>
    <span>{{ 'dataManagement.validator.titleSystems' | transloco }}</span>
  </button>
  <button mat-menu-item *ngIf="isValidator" (click)="clickValidatorUnits()" type="button">
    <mat-icon>folder</mat-icon>
    <span>{{ 'dataManagement.validator.titleUnits' | transloco }}</span>
  </button>
  <button *ngIf="!isValidator && !isAdmin" mat-menu-item (click)="clickExcelUpload()" type="button">
    <mat-icon>input</mat-icon>
    <span>{{ 'dataManagement.import.titleExcelImport' | transloco }}</span>
  </button>
  <button *ngIf="!isValidator && !isAdmin" mat-menu-item (click)="clickPackagingImport()" type="button">
    <mat-icon>input</mat-icon>
    <span>{{ 'dataManagement.import.titlePackagingImport' | transloco }}</span>
  </button>
  <button mat-menu-item *ngIf="isGs1DataTransferUser" (click)="clickGs1DataTransfer()" type="button">
    <mat-icon>output</mat-icon>
    <span>{{ 'dataManagement.gs1DataTransfer.title' | transloco }}</span>
  </button>
  <button *ngIf="!isValidator && !isAdmin" mat-menu-item (click)="clickDataExchangeRequests()" type="button">
    <mat-icon>swap_horiz</mat-icon>
    <span>{{ 'dataManagement.dataExchangeRequests.menuTitle' | transloco }}</span>
  </button>
  <button *ngIf="!isValidator" mat-menu-item (click)="clickTags()" type="button">
    <mat-icon>signpost</mat-icon>
    <span>{{ 'dataManagement.tags.titleTags' | transloco }}</span>
  </button>
  <button mat-menu-item (click)="clickUsers()" type="button">
    <mat-icon>supervisor_account</mat-icon>
    <span>{{ 'dataManagement.userData.title' | transloco }}</span>
  </button>
  <button mat-menu-item *ngIf="isAdmin" (click)="clickManageOrganizations()" type="button">
    <mat-icon>account_balance</mat-icon>
    <span>{{ 'dataManagement.manageOrganizations.menuTitle' | transloco }}</span>
  </button>
  <button mat-menu-item *ngIf="isAdmin" (click)="clickImportLcaExcelData()" type="button">
    <mat-icon>rocket_launch</mat-icon>
    <span>{{ 'dataManagement.lcaExcelDataImport.title' | transloco }}</span>
  </button>
  <button mat-menu-item *ngIf="isAdmin" (click)="clickSync()" type="button">
    <mat-icon>sync</mat-icon>
    <span>{{ 'dataManagement.synchronizeDb.title' | transloco }}</span>
  </button>
  <button mat-menu-item *ngIf="!isValidator" (click)="clickExportProfiles()" type="button">
    <mat-icon>view_module</mat-icon>
    <span>{{ 'dataManagement.exportProfiles.title' | transloco }}</span>
  </button>
  <button mat-menu-item *ngIf="!isAdmin && !isValidator" type="button" [matMenuTriggerFor]="reportsMenu.menu">
    <mat-icon>topic</mat-icon>
    <span>{{ 'report.title' | transloco }}</span>
  </button>
  <!-- <button mat-menu-item type="button" (click)="clickInternationalInfos()">
    <mat-icon>public</mat-icon>
    <span>{{ 'dataManagement.internationalInfos.title' | transloco }}</span>
  </button> -->
  <app-reports-menu #reportsMenu></app-reports-menu>
  <button mat-menu-item (click)="clickVersions()" type="button">
    <mat-icon>grading</mat-icon>
    <span>{{ 'dataManagement.versions.title' | transloco }}</span>
  </button>
  <button mat-menu-item (click)="clickUiChangelog()" type="button">
    <mat-icon>history</mat-icon>
    <span>{{ 'dataManagement.uiChangelog.title' | transloco }}</span>
  </button>
</mat-menu>
